import { duracaoNoPeriodoMs } from './horas.js';
import { calcularMes } from './mes.js';
function validarAnoMes({ ano, mes }) {
    if (!Number.isInteger(ano) ||
        ano < 2000 ||
        ano > 2100 ||
        !Number.isInteger(mes) ||
        mes < 1 ||
        mes > 12) {
        throw new RangeError(`Ano e mês fora do intervalo aceito: ${ano}/${mes}`);
    }
}
function ordemDoMes({ ano, mes }) {
    return ano * 12 + mes;
}
export function calcularSerie(entrada) {
    validarAnoMes(entrada.inicio);
    validarAnoMes(entrada.fim);
    if (ordemDoMes(entrada.inicio) > ordemDoMes(entrada.fim)) {
        throw new RangeError('O início da série deve anteceder ou igualar o fim');
    }
    let transporte = entrada.transporteInicial;
    const resultados = [];
    const fim = new Date(entrada.fim.ano, entrada.fim.mes - 1, 1);
    // O avanço usa o calendário local para atravessar dezembro e inclui meses
    // vazios. Saltar direto para o próximo mês com sessões perderia o
    // transporte que precisa chegar intacto a essa atividade futura.
    for (let data = new Date(entrada.inicio.ano, entrada.inicio.mes - 1, 1); data <= fim; data = new Date(data.getFullYear(), data.getMonth() + 1, 1)) {
        const ano = data.getFullYear();
        const mes = data.getMonth() + 1;
        const existente = entrada.existentes.find((item) => item.ano === ano && item.mes === mes);
        // `calcularMes` continua sendo a única autoridade sobre totais,
        // sobrescrita, envio e updated_at. A série só encadeia o transporte.
        const calculado = calcularMes({
            id: entrada.id(ano, mes),
            ano,
            mes,
            perfil: entrada.perfil,
            sessoes: entrada.sessoes,
            estudos: entrada.estudos,
            visitas: entrada.visitas,
            transporteAnterior: transporte,
            agora: entrada.agora,
            ...(existente === undefined ? {} : { existente }),
        });
        resultados.push(calculado);
        transporte = calculado.transporte_minutos;
    }
    return resultados;
}
function proximaSegunda(data) {
    const dias = data.getDay() === 0 ? 1 : 8 - data.getDay();
    // Somar dias ao construtor preserva a meia-noite do calendário local.
    // Somar 7 × 24 h falha nas semanas em que o relógio civil muda.
    return new Date(data.getFullYear(), data.getMonth(), data.getDate() + dias);
}
function limitesExclusivos(inicio, fim) {
    return {
        de: inicio.toISOString(),
        // `duracaoNoPeriodoMs` recebe o contrato inclusivo de Limites; esta é a
        // única conversão porque SemanaDoMes expõe o fim exclusivo.
        ate: new Date(fim.getTime() - 1).toISOString(),
    };
}
export function semanasDoMes(sessoes, ano, mes, agora) {
    validarAnoMes({ ano, mes });
    const inicioDoMes = new Date(ano, mes - 1, 1);
    const fimDoMes = new Date(ano, mes, 1);
    const semanas = [];
    for (let inicio = inicioDoMes; inicio < fimDoMes;) {
        const segunda = proximaSegunda(inicio);
        const fim = segunda < fimDoMes ? segunda : fimDoMes;
        const limites = limitesExclusivos(inicio, fim);
        let campoMs = 0;
        let creditosMs = 0;
        for (const sessao of sessoes) {
            const duracao = duracaoNoPeriodoMs(sessao, limites, agora);
            if (sessao.categoria === 'credito')
                creditosMs += duracao;
            else
                campoMs += duracao;
        }
        semanas.push({
            de: inicio.toISOString(),
            ate: fim.toISOString(),
            campoMs,
            creditosMs,
        });
        inicio = fim;
    }
    return semanas;
}
//# sourceMappingURL=serie.js.map